import { render, staticRenderFns } from "./Comportamiento.vue?vue&type=template&id=55c4c58a"
import script from "./Comportamiento.vue?vue&type=script&lang=js"
export * from "./Comportamiento.vue?vue&type=script&lang=js"
import style0 from "./Comportamiento.vue?vue&type=style&index=0&id=55c4c58a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports